import type React from 'react';
import { useTranslation } from 'react-i18next';

type ButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  isLoading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  // 新增 tabIndex 属性用于控制 tab 顺序
  tabIndex?: number;
};

export const Button = ({
  onClick,
  disabled = false,
  children,
  variant = 'primary',
  className = '',
  isLoading = false,
  type = 'button',
  tabIndex,
}: ButtonProps) => {
  const { t } = useTranslation();
  const baseClasses =
    'w-full rounded-[4px] px-[24px] py-[8px] text-[16px] font-medium disabled:opacity-50 disabled:cursor-not-allowed';

  const variantClasses = {
    primary: 'bg-[#326BFB] text-white hover:bg-[#2557d4] disabled:bg-[#326BFB] disabled:opacity-50',
    secondary: 'border border-solid border-[#ebedf0] bg-[#f5f7fa] text-[#23343e]',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || isLoading}
      tabIndex={tabIndex}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      {isLoading ? t('components.button.loading') : children}
    </button>
  );
};